<template>
	<div class="m-report-charts__barchart">
		<BarChart
			:chart-id="idChart"
			:chartData="getChartDataSet"
			:options="chartOptions"
			width="320"
			:height="chartHeight"
			v-if="isDone"
		/>
	</div>

	<div class="m-report-charts__legend">
		<div
			class="m-report-charts__legend--wrapper"
			v-for="item in getLegend"
			:key="item.type"
		>
			<div
				class="m-report-charts__legend--icon"
				:style="{ backgroundColor: item.bgc }"
			></div>
			<div class="m-report-charts__legend--name">
				{{ item.name }}

				<template v-if="hint && hint[item.type]">
					<tooltip-wrapper
						class="m-report-charts--tooltip"
						arrow="arrow"
						placement="bottom-start"
					>
						<svg
							width="16"
							height="16"
							viewBox="0 0 16 16"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M8 1.33333C4.3181 1.33333 1.33333 4.3181 1.33333 8C1.33333 11.6819 4.3181 14.6667 8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33333 8 1.33333ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
								fill="#999999"
							/>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M6.83333 7.5C6.83333 7.13181 7.13181 6.83333 7.5 6.83333H8C8.36819 6.83333 8.66667 7.13181 8.66667 7.5V10.3543C8.9542 10.4283 9.16667 10.6894 9.16667 11C9.16667 11.3682 8.86819 11.6667 8.5 11.6667H8C7.63181 11.6667 7.33333 11.3682 7.33333 11V8.14566C7.0458 8.07166 6.83333 7.81064 6.83333 7.5Z"
								fill="#999999"
							/>
							<path
								d="M7.875 6C8.28921 6 8.625 5.66421 8.625 5.25C8.625 4.83579 8.28921 4.5 7.875 4.5C7.46079 4.5 7.125 4.83579 7.125 5.25C7.125 5.66421 7.46079 6 7.875 6Z"
								fill="#999999"
							/>
						</svg>
						<template #content>
							<div class="popper-subtitle" v-html="hint[item.type]"></div>
						</template>
					</tooltip-wrapper>
				</template>
			</div>
		</div>
	</div>
	<div class="m-report-charts__legend--block">
		<div class="m-report-charts__legend--block-wrapper">
			<div class="m-report-charts__legend--source" v-if="addText">
				{{ addText }}
			</div>
			<div class="m-report-charts__legend--source">
				{{ sources }}&nbsp;<template v-if="hint && hint?.product_sources">
					<tooltip-wrapper
						class="m-report-charts--tooltip m-report-charts--tooltip-source"
						arrow="arrow"
						placement="bottom-start"
					>
						<svg
							width="16"
							height="16"
							viewBox="0 0 16 16"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M8 1.33333C4.3181 1.33333 1.33333 4.3181 1.33333 8C1.33333 11.6819 4.3181 14.6667 8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33333 8 1.33333ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
								fill="#999999"
							/>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M6.83333 7.5C6.83333 7.13181 7.13181 6.83333 7.5 6.83333H8C8.36819 6.83333 8.66667 7.13181 8.66667 7.5V10.3543C8.9542 10.4283 9.16667 10.6894 9.16667 11C9.16667 11.3682 8.86819 11.6667 8.5 11.6667H8C7.63181 11.6667 7.33333 11.3682 7.33333 11V8.14566C7.0458 8.07166 6.83333 7.81064 6.83333 7.5Z"
								fill="#999999"
							/>
							<path
								d="M7.875 6C8.28921 6 8.625 5.66421 8.625 5.25C8.625 4.83579 8.28921 4.5 7.875 4.5C7.46079 4.5 7.125 4.83579 7.125 5.25C7.125 5.66421 7.46079 6 7.875 6Z"
								fill="#999999"
							/>
						</svg>
						<template #content>
							<div class="popper-subtitle" v-html="hint?.product_sources"></div>
						</template>
					</tooltip-wrapper>
				</template>
			</div>
		</div>
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M31.9999 18.84H0.0551758V20.6959H31.9999V18.84Z"
				fill="#DEDEDE"
			/>
			<path
				d="M0.0551758 31.9999H2.0236V29.8628H13.2155V22.5518H0.0551758V31.9999ZM2.0236 24.4077H11.2471V28.0069H2.0236V24.4077Z"
				fill="#DEDEDE"
			/>
			<path
				d="M15.0735 29.8629H22.4973V32H24.5219V29.8629H31.9457V22.5519H15.0735V29.8629ZM24.5219 24.4078H30.0335V28.0071H24.5219V24.4078ZM17.0419 24.4078H22.4973V28.0071H17.0419V24.4078Z"
				fill="#DEDEDE"
			/>
			<path
				d="M16.9845 0H9.44824V16.9278H16.9845V0ZM15.0161 15.0719H11.4167V1.91211H15.0161V15.0719Z"
				fill="#DEDEDE"
			/>
			<path
				d="M20.8649 5.6801L24.4643 1.91211V16.984H26.4327V5.6801L29.9759 1.91211V16.984H31.9443V0H29.1885L26.4327 2.92441V0H23.6769L18.8965 4.94899V16.984H20.8649V5.6801Z"
				fill="#DEDEDE"
			/>
			<path
				d="M5.56783 16.984H7.53625V15.1282V0H4.78046L0 4.94899V15.0719V16.9278H1.96842H5.56783V16.984ZM2.02466 5.6801L5.62407 1.91211V15.0719H2.02466V5.6801Z"
				fill="#DEDEDE"
			/>
		</svg>
	</div>
</template>

<script>
import TooltipWrapper from './TooltipWrapper'
import { BarChart } from 'vue-chart-3'
import { Chart, registerables } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'

Chart.register(...registerables, ChartDataLabels)

export default {
	name: 'ProductChart',
	components: { BarChart, TooltipWrapper },
	props: {
		idChart: {
			type: String,
		},
		data: {
			type: Object,
		},
		sources: {
			type: String,
		},
		hint: {
			type: Object,
		},
		limit: {
			type: Number,
		},
		addText: {
			type: String,
		},
	},
	data() {
		return {
			origin: [],
			legend: [],
			isDone: false,
			info: [],
			max: null,
			chartDataSet: {
				labels: ['one', 'two', 'three', 'four', 'five'],
				datasets: [
					{
						data: [1, 2, 3, 4],
						stack: 'stack 0',
						backgroundColor: ['green', '#77CEFF', '#77CEFF'],
						borderRadius: {
							topLeft: 10,
							topRight: 10,
							bottomLeft: 0,
							bottomRight: 0,
						},
					},
					{
						data: [1, 2, 3, 4],
						stack: 'stack 0',
						backgroundColor: ['blue', 'yellow', 'magenta'],
					},
					{
						data: [1, 2, 3, 4],
						stack: 'stack 0',
						backgroundColor: ['blue', 'yellow', 'magenta'],
					},
				],
			},
			chartOptions: {
				animations: false,
				responsive: true,
				maintainAspectRatio: false,
				borderSkipped: false,
				borderColor: 'transparent',
				borderWidth: {
					top: 4,
				},
				onHover: (event, chartElement) => {
					if (chartElement.length === 1) {
						event.native.target.style.cursor = 'pointer'
					}
					if (chartElement.length === 0) {
						event.native.target.style.cursor = 'default'
					}
				},
				barPercentage: () =>
					document.documentElement.clientWidth <= 650 ? 0.85 : 0.75,
				borderRadius: {
					topLeft: 8,
					topRight: 8,
					bottomLeft: 4,
					bottomRight: 4,
				},
				layout: {
					padding: {
						top: 40,
						right: () => (document.documentElement.clientWidth <= 650 ? 0 : 25),
						left: 0,
					},
				},
				plugins: {
					legend: {
						display: false,
					},
					tooltip: {
						// Disable the on-canvas tooltip
						enabled: false,
						animation: false,
						external: context => {
							window.addEventListener('resize', function () {
								setTimeout(() => {
									tooltipEl.style.opacity = 0
									tooltipEl.classList.remove('active')
								}, 100)
							})
							// Hide if no tooltip
							const tooltipModel = context.tooltip
							let activeCanvas = tooltipModel.chart.canvas.id

							// Tooltip Element
							let tooltipEl = document.getElementById(
								`chartjs-tooltip-${this.idChart}`
							)

							// Create element on first render
							if (!tooltipEl) {
								let parent = document.getElementById(`${this.idChart}`)
								tooltipEl = document.createElement('div')
								tooltipEl.id = `chartjs-tooltip-${this.idChart}`
								tooltipEl.innerHTML =
									'<div class="chartjs-tooltip-wrapper"></div>'
								document.body.appendChild(tooltipEl)
							} else {
								tooltipEl.setAttribute('activeCanvas', activeCanvas)
							}

							if (tooltipModel.opacity === 0) {
								tooltipEl.style.opacity = 0
								tooltipEl.classList.remove('active')
								return
							}

							let btn

							// Set caret Position
							tooltipEl.classList.remove('above', 'below', 'no-transform')
							if (tooltipModel.yAlign) {
								tooltipEl.classList.add(tooltipModel.yAlign)
							} else {
								tooltipEl.classList.add('no-transform')
							}
							if (tooltipModel.caretX > tooltipEl.offsetWidth) {
								tooltipEl.style.left = `${tooltipEl.offsetWidth}px`
							}

							function getBody(bodyItem) {
								return bodyItem.lines
							}

							// Set Text

							if (tooltipModel.body) {
								const info =
									tooltipModel.dataPoints[0].dataset.info[
										tooltipModel.dataPoints[0].dataIndex
									]
								const titleLines = tooltipModel.title || []

								let bg = tooltipModel.labelColors[0].backgroundColor

								let btn_close = `<button class="chartjs-tooltip__button-close"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#252628"></rect>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2092 11.2092C11.4882 10.9303 11.9404 10.9303 12.2194 11.2092L16 14.9898L19.7806 11.2092C20.0596 10.9303 20.5118 10.9303 20.7908 11.2092C21.0697 11.4882 21.0697 11.9404 20.7908 12.2194L17.0102 16L20.7908 19.7806C21.0697 20.0596 21.0697 20.5118 20.7908 20.7908C20.5118 21.0697 20.0596 21.0697 19.7806 20.7908L16 17.0102L12.2194 20.7908C11.9404 21.0697 11.4882 21.0697 11.2092 20.7908C10.9303 20.5118 10.9303 20.0596 11.2092 19.7806L14.9898 16L11.2092 12.2194C10.9303 11.9404 10.9303 11.4882 11.2092 11.2092Z" fill="#252628"></path>
                                </svg></button>`

								let title = `<div class="chartjs-tooltip__title" style="background-color: ${bg}">${titleLines}</div>`

								let name = `<div class="chartjs-tooltip__name">${info.name}</div>`

								let quantity = `<div class="chartjs-tooltip__block ${
									info.quantity_growth && info.volume_growth !== '-'
										? ''
										: 'chartjs-tooltip__block-mb'
								}">
                                    <div class="chartjs-tooltip__quantity-txt">Количество выданных</br> кредитов</div>
                                    <div class="chartjs-tooltip__quantity">${this.formatCurrency(
																			info.quantity
																		)}&nbsp;тыс.&nbsp;шт.</div></div>`

								let quantity_growth =
									info.quantity_growth && info.volume_growth !== '-'
										? `<div class="chartjs-tooltip__block chartjs-tooltip__block-mb">
                                    <div class="chartjs-tooltip__q-growth-txt">Прирост за год</div><div class="chartjs-tooltip__q-growth">${this.toNumber(
																			info.quantity_growth
																		)}&nbsp;%</div></div>`
										: ''

								let quantity_volume = `<div class="chartjs-tooltip__block">
                                    <div class="chartjs-tooltip__quantity-txt">Объем выданных</br> кредитов</div><div class="chartjs-tooltip__quantity">${this.formatCurrency(
																			info.volume
																		)}&nbsp;млрд&nbsp;₽</div></div>`

								let volume_growth =
									info.volume_growth && info.volume_growth !== '-'
										? `<div class="chartjs-tooltip__block">
                                    <div class="chartjs-tooltip__q-growth-txt">Прирост за год</div><div class="chartjs-tooltip__q-growth">${this.toNumber(
																			info.volume_growth
																		)}&nbsp;%</div>`
										: ''

								let innerHtml =
									`<div class="chartjs-tooltip__header"><div class="chartjs-tooltip__header-wrapper">${title}${name}</div>${btn_close}</div>` +
									quantity +
									quantity_growth +
									quantity_volume +
									volume_growth

								let root = tooltipEl.querySelector('div')
								root.innerHTML = innerHtml
							}

							const position = context.chart.canvas.getBoundingClientRect()

							// Display, position, and set styles for font
							if (document.documentElement.clientWidth > 767) {
								tooltipEl.style.opacity = 1
								tooltipEl.style.position = 'absolute'
								tooltipEl.classList.add('active')

								if (tooltipModel.caretX > tooltipEl.offsetWidth - 50) {
									tooltipEl.style.left =
										position.left +
										window.pageXOffset +
										tooltipModel.caretX -
										tooltipEl.offsetWidth +
										'px'
								} else {
									tooltipEl.style.left =
										position.left +
										window.pageXOffset +
										tooltipModel.caretX +
										'px'
								}
								tooltipEl.style.top =
									position.top + window.pageYOffset + tooltipModel.caretY + 'px'
								tooltipEl.style.padding =
									tooltipModel.padding + 'px ' + tooltipModel.padding + 'px'
								tooltipEl.style.pointerEvents = 'none'
							} else {
								tooltipEl.classList.add('active')
								tooltipEl.style.opacity = 1
								tooltipEl.style.position = 'fixed'
								tooltipEl.style.left = '0'
								tooltipEl.style.top = '0'
								tooltipEl.style.bottom = '0'
							}

							btn = document.querySelector(
								`#chartjs-tooltip-${this.idChart} .chartjs-tooltip__button-close`
							)

							if (btn) {
								btn.addEventListener('click', closePopup)
							}

							function closePopup() {
								tooltipEl.classList.remove('active')
								tooltipEl.style.opacity = 0
								tooltipEl.style.left = 'unset'
								tooltipEl.style.top = 'unset'
								tooltipEl.style.bottom = 'unset'
								if (btn) {
									btn.removeEventListener('click', closePopup)
								}
								tooltipEl.remove()
							}
						},
					},

					datalabels: {
						labels: {
							value: {
								color: '#252628',
								font: () => {
									let font = {
										size: this.isMobile() ? 10 : 14,
										family: 'Gilroy-Medium, sans-serif',
										weight: '500',
										lineHeight: 0,
									}
									return font
								},
								backgroundColor: 'red',
								// clip: true,
								// clamp: true,
								textAlign: 'center',
								align: 'start',
								offset: 3,
								rotation: 0,
								padding: {
									top: 0,
									bottom: 0,
								},
								formatter: (value, index) => {
									// Решение с лимитом
									let val = index.dataset.info[index.dataIndex].quantity_percent
									if (Number(this.limit) > 1) {
										if (Number(val) > Number(this.limit)) {
											return val + '%'
										} else {
											return ''
										}
									} else {
										let height = Number(
											index.chart._metasets[index.datasetIndex].data[
												index.dataIndex
											].height
										)
										let currentValue =
											index.dataset.info[index.dataIndex].quantity_percent
										if (Math.round(height) > 15) {
											return currentValue + '%'
										} else return ''
									}
									// Решение с автообрезкой не помещающихся в ячейку цифр
									// if (Math.round(index.chart._metasets[index.datasetIndex].data[index.dataIndex].height) > 15) {
									//     return `${index.dataset.info[index.dataIndex].quantity_percent}%`;
									// } else return ''

									// Дефолтное решение
									// return `${index.dataset.info[index.dataIndex].quantity_percent}%`;
								},
							},
							title: {
								formatter: (value, context) => {
									if (
										context.datasetIndex ===
										this.chartDataSet.datasets.length - 1
									) {
										return this.origin[context.dataIndex].total
									} else return ''
								},
								anchor: 'end',
								color: '#252628',
								align: 'top',
								offset: 0,
								padding: { top: 0, left: 0, right: 0, bottom: 0 },
								font: {
									size: this.isMobile() ? 14 : 16,
									family: 'Gilroy-SemiBold, sans-serif',
									weight: '600',
								},
							},
						},
					},
				},
				scales: {
					x: {
						stacked: true,
						ticks: {
							color: '#999',
							font: {
								size: 12,
								family: 'Gilroy-Medium, sans-serif',
								weight: '500',
							},
							offset: 10,
							callback: function (value, index, ticks) {
								let val = this.getLabelForValue(value)
								let splittedValue = val.split(' ')
								let newVal
								if (splittedValue.length > 2) {
									newVal = splittedValue.slice(0, -1).join(' ')

									return [newVal, splittedValue[splittedValue.length - 1]]
								}
								return splittedValue
							},
						},
						grid: {
							// display: false
							borderColor: '#999',
							color: 'transparent',
						},
					},
					y: {
						stacked: true,
						beginAtZero: true,
						suggestedMax: () => {
							return this.max
						},
						ticks: {
							color: '#999',
							font: {
								size: () =>
									document.documentElement.clientWidth >= 650 ? 12 : 10,
								family: 'Gilroy-Medium, sans-serif',
								weight: '500',
							},
							callback: function (value, index, ticks) {
								if (index === ticks.length - 1) {
									return document.documentElement.clientWidth >= 767
										? ['тысяч', 'кредитов']
										: ['тысяч', 'кред.']
								} else if (index === 0) {
									return ''
								} else return value
							},
						},
						grid: {
							// display: false,
							color: '#efefef',
							borderColor: '#999',
							borderDash: [5, 2],
						},
					},
				},
			},
		}
	},
	computed: {
		getChartDataSet() {
			return this.chartDataSet
		},
		chartHeight() {
			let clientWidth = document.documentElement.clientWidth
			if (clientWidth >= 650 && clientWidth < 1024) {
				return 500
			} else if (clientWidth >= 1024) {
				return 550
			} else return 350
		},

		getLegend() {
			const legend = this.legend
			return legend.map(el => el).reverse()
		},
	},

	mounted() {
		let backgroundColor = ['#c3b5e1', '#fad248', '#9ac2ff', '#82bf00']

		let keys = this.data.map(el => {
			return Object.keys(el).filter(key => {
				return typeof el[key] === 'object' ? key : false
			})
		})

		let flattenedArray = [].concat(...keys)
		let uniqKey = Array.from(new Set(flattenedArray)).reverse()
		this.chartDataSet.datasets = new Array(uniqKey.length)
		this.chartDataSet.labels.length = 0
		this.data.forEach(el => {
			this.chartDataSet.labels.push(el.period)
		})

		function setBackgroundColor(key, index) {
			let bg = []
			uniqKey.forEach(key => {
				bg.push(backgroundColor[index])
			})
			return bg
		}

		uniqKey.forEach((key, index) => {
			this.chartDataSet.datasets[index] = {
				data: [],
				stack: 'stack 0',
				backgroundColor: setBackgroundColor(key, index),
				label: null,
				info: [],
				borderRadius: {
					topLeft: 8,
					topRight: 8,
					bottomLeft: index === 0 ? 0 : 4,
					bottomRight: index === 0 ? 0 : 4,
				},
			}
			this.data.forEach((el, idx) => {
				if (el[key]) {
					this.chartDataSet.datasets[index].data.push(el[key].quantity)
					this.chartDataSet.datasets[index].info.push(el[key])
				}
			})
		})

		uniqKey.forEach((el, idx) => {
			this.legend.push(this.data[0][el])
			this.legend[idx].bgc = backgroundColor[idx]
		})

		if (document.documentElement.clientWidth <= 649) {
			this.origin = this.data.slice(2)
			this.chartDataSet.labels = this.chartDataSet.labels.slice(2)
			this.chartDataSet.datasets.forEach(el => {
				let arr = el.data.slice(2)
				el.data = []
				el.data = arr
				arr = []
				arr = el.info.slice(2)
				el.info = []
				el.info = arr
			})
		} else {
			this.origin = this.data
		}

		let maxQuantity = this.chartDataSet.datasets.map(el => el.data)
		let length = maxQuantity[0].length
		let arrMax = []

		for (let i = 0; i < length; i++) {
			let mmax = 0
			maxQuantity.forEach((el, idx) => {
				mmax += Number(el[i])
			})
			arrMax.push(mmax)
		}
		this.max = Math.max(...arrMax)
		this.isDone = true
	},
	methods: {
		toNumber(val) {
			if (Number(val) > 0) {
				return `+${val}`
			} else return val
		},
		isMobile() {
			return document.documentElement.clientWidth <= 650
		},
		formatCurrency(value) {
			let rub = value.replace(/[^0-9,]/g, '').replace(',', '.')
			let formatRubles = new Intl.NumberFormat('ru').format(rub)
			return formatRubles
		},
	},
}
</script>
